import type { Href, RoutePath, RouteSegments } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

export const TABS = {
  ACCOUNT: 'account',
  GIFT: 'gift',
  HOME: '(home)',
  HOME_SINGLE: 'home',
  MENU: '(menu)',
  MENU_SINGLE: 'menu',
  REWARDS: 'rewards',
} as const satisfies Record<string, RouteSegment>;

export const ROUTE_GROUPS = {
  CUSTOMIZATION: '(customization)',
} as const satisfies Record<string, RouteSegment>;

export const LINKS = {
  ACCOUNT: '/account',
  AUTH: { pathname: '/(auth)/join-or-sign-in', params: { redirect: '/' } },
  BAG: '/bag',
  GIFT: '/gift',
  LOCATIONS: '/locations',
  LOCATION_SELECTION: '/location-selection',
  ORDER_HISTORY: '/account/orders',
  REWARDS: '/rewards',
} as const satisfies Record<string, Href>;

export const MENU_VIEWS = {
  CATEGORIES: 'categories',
  MENU: 'menu',
} as const;

export const NAVBAR_TAB_NAMES = [TABS.HOME, TABS.MENU, TABS.ACCOUNT] as const;

export const NAVBAR_BAG_ICON_SIZE = 24;
export const NAVIGATION_CONTENT_TYPE = 'navigation';

// ─── Types ───────────────────────────────────────────────────────────────────

type RouteSegment = RouteSegments<RoutePath>[number];
